<template>
    <div
        :class="twMerge(tagVariants({ variant, disabled, outline, size, clickable: clickable || closable }), $attrs.class as string)"
        @click="handleClick"
    >
        <span>
            <slot />
        </span>

        <!-- @vue-expect-error baseline -->
        <NumberIndicator
            v-if="!isNil(badge)"
            :badge="badge"
            outline
            :variant="props.variant"
            :disabled="disabled"
        />

        <button
            v-if="closable"
            :disabled="disabled"
            :class="{ 'cursor-not-allowed': disabled }"
            @click.stop="emit('close')"
        >
            <Icon name="close" :size="props.size === 'sm' ? 16 : 20" class="text-secondary" />
        </button>
    </div>
</template>

<script setup lang="ts">
import { isNil } from 'lodash'
import { twMerge } from 'tailwind-merge'
import Icon from '@/vue/components/design-system/icon/Icon.vue'
import { NumberIndicator } from '../indicator'
import { tagVariants } from './tagVariants'
import type { TagProps } from './types'

const props = withDefaults(defineProps<TagProps>(), {
    variant: 'default',
    size: 'md',
    disabled: false,
    outline: false,
    clickable: false,
    closable: false,
})

const emit = defineEmits<{
    (e: 'close'): void
    (e: 'click'): void
}>()

const handleClick = () => {
    if (!props.disabled) {
        emit('click')
    }
}
</script>
